import React, { useState } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import styled from "styled-components";
import {
  ReactComponent as ArrowLeft,
  ReactComponent as ArrowRight,
} from "../../../../src/assets/arrow.svg";
import {
  BASIC_BLACK,
  BASIC_LINE,
  BASIC_WHITE,
} from "../../../constants/colors";
import { Banner } from "../../../ducks/banner";

type Props = {
  banners: Banner[];
};

export const BannerSlideShow: React.FC<Props> = ({ banners }) => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  return (
    <CarouselContainer>
      <Slide
        autoplay={banners.length > 1}
        infinite={banners.length > 1}
        duration={4000}
        transitionDuration={250}
        easing="ease"
        pauseOnHover={false}
        canSwipe={banners.length > 1}
        arrows={banners.length > 1}
        prevArrow={
          <CustomArrowLeft>
            <ArrowLeft />
          </CustomArrowLeft>
        }
        nextArrow={
          <CustomArrowRight>
            <ArrowRight />
          </CustomArrowRight>
        }
        indicators={(index?: number) => {
          if (banners.length === 1) return <></>;

          return (
            <BannerIndicator key={index} selected={index === currentSlide} />
          );
        }}
        onChange={(from, to) => setCurrentSlide(to)}
      >
        {banners.map((banner) => (
          <BannerContainer key={banner.id}>
            <BannerImage width="100%" height="100%" src={banner.image} alt="" />
          </BannerContainer>
        ))}
      </Slide>
    </CarouselContainer>
  );
};

const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

const BannerContainer = styled.div`
  max-height: 450px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  select: none;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }

  @media (min-width: 1024px) {
    //margin: 10% 0;
  }
`;

const BannerImage = styled.img`
  object-fit: scale-down;
`;

const BannerIndicator = styled.div<{ selected: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ selected }) => (selected ? BASIC_BLACK : BASIC_LINE)};
  display: inline-block;
  margin: 0 8px;
  cursor: pointer;
`;

const CustomArrowBase = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.25);
  color: ${BASIC_WHITE};
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  padding: 5px;
  cursor: pointer;
  z-index: 2;
`;

const CustomArrowLeft = styled(CustomArrowBase)`
  left: 10px;
  margin-left: 5px;
`;

const CustomArrowRight = styled(CustomArrowBase)`
  right: 10px;
  margin-right: 5px;
  transform: translateY(-50%) rotate(180deg);
`;
